<template>
  <div class="section-review-header">
    <span
      v-if="isSimulationComplete"
      class="inline-row"
    >
      <span>{{ correctCount }}/{{ totalQuestions }} Correct</span>
      <button
        class="button-icon"
        tabindex="0"
        title="Return to Performance"
        @click="handleReturnToPerformance"
        @keydown.enter="handleReturnToPerformance"
      >
        <icon
          name="arrow-in-box"
          class="icon"
        ></icon>
      </button>
    </span>
    <span
      v-else
    >
      {{ formattedTime }}
    </span>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon.vue';

export default {
  components: {
    Icon,
  },
  props: {
    isSimulationComplete: {
      type: Boolean,
      required: true,
    },
    correctCount: {
      type: Number,
      default: 0,
    },
    totalQuestions: {
      type: Number,
      default: 0,
    },
    formattedTime: {
      type: String,
      default: '',
    },
  },
  emits: ['return-to-performance'],
  methods: {
    handleReturnToPerformance() {
      this.$emit('return-to-performance');
    },
  },
};
</script>

<style lang='scss' scoped>
.section-review-header {
  line-height: 4.5rem;
  font-size: 1.25rem;
  font-weight: 600;
  padding-right: 2.5rem;
  color: white;
  display: flex;
  justify-content: flex-end;
}

.button-icon {
  background-color: transparent;
  padding: 0;
  margin: 0;
  line-height: 0;
}

.icon {
  width: 1.5rem;
  height: 1.5rem;
}

.inline-row {
  display: flex;
  align-items: center;
  gap: 1.25rem;
}
</style>
